jQuery(document).ready(function(){
	jQuery(window).scroll(function() {
		checkAnimatedBlock();
	})
	checkAnimatedBlock();
})
function checkAnimatedBlock(){
	let animatedBlocks = jQuery('.animate__animated.animation-extend');
	animatedBlocks.each(function(){
		let block = jQuery(this);
		let tempBlock = jQuery('<div/>')
			.css('min-height', block.outerHeight(true))
			.css('min-width', block.outerWidth(true))
			.css('position', 'relative')
			.addClass('animation-temp-block');
		checkIfItemIsVisible(
			block,
			()=>{
				if(block.hasClass("paused")){
					setTimeout(function(){
						block.addClass("play");
						block.removeClass("paused");
					},100);
					setTimeout(function(){
						block.removeClass("play");
						block.addClass("ended")
					}, 1100)
				}
			},
			()=>{if(block.hasClass("animation-loop"))block.addClass('paused')}
		);
	})
}
function checkIfItemIsVisible(item, callBackTrue=()=>{}, callBackFalse=()=>{}){
	let Jwindow = jQuery(window);

	let topOfElement = item.offset().top;
	let bottomOfElement = item.offset().top+item.height();

	let topScrollPositionOnScreen = Jwindow.scrollTop();
	let bottomScrollPositionOnScreen = topScrollPositionOnScreen +Jwindow.outerHeight(true);

	if (bottomScrollPositionOnScreen>topOfElement && topScrollPositionOnScreen<bottomOfElement){
		callBackTrue();
	}else{
		callBackFalse();
	}
}
